import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { Language } from '@/shared/enums/languagesEnum'

export class ChannelActiveRegionEntity {
  region?: RegionMiniEntity
  coverImages?: Array<{
    coverImage?: FileUploadEntity
    serviceCoverImage?: FileUploadEntity
    serviceImageUrl?: string
    imageUrl?: string
    language?: Language
    file?: File
    serviceFile?: File
  }>
}
